import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useState, useCallback } from 'react';
import GroupGallectionSelector from '../../../GroupGallectionSelector';
import MediaSelector from '../../MediaSelector/MediaSelector';
const MediaSelectorWithGroupGallection = (_param)=>{
    var { group, gallectionType = 'gallery', initialGroupGallection = undefined, onSelect } = _param, props = _object_without_properties(_param, [
        "group",
        "gallectionType",
        "initialGroupGallection",
        "onSelect"
    ]);
    const [selectedGallection, setSelectedGallection] = useState(initialGroupGallection);
    const onGroupGallectionSelect = useCallback((gallection)=>setSelectedGallection(gallection), []);
    const onSelectCallback = useCallback((deviations)=>onSelect(deviations, group, gallectionType, selectedGallection === null || selectedGallection === void 0 ? void 0 : selectedGallection.folderId), [
        onSelect,
        group,
        gallectionType,
        selectedGallection
    ]);
    return /*#__PURE__*/ React.createElement(MediaSelector, _object_spread_props(_object_spread({}, props), {
        subheading: /*#__PURE__*/ React.createElement(GroupGallectionSelector, {
            group: group,
            gallectionType: gallectionType,
            selected: selectedGallection,
            onSelect: onGroupGallectionSelect
        }),
        onSelect: onSelectCallback
    }));
};
MediaSelectorWithGroupGallection.displayName = 'MediaSelectorWithGroupGallection';
export default MediaSelectorWithGroupGallection;

//# sourceMappingURL=MediaSelectorWithGroupGallection.js.map